// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostReviewIntelligentPartnerAiFinishBody,
    BaseResponseAiDialogFinishResultResponse,
} from '../../../../types';

/**
 * ai练习结束
 *
 * @export
 * @tags 智能陪练-对话流程(节点, 全局配置, 客户画像)
 * @link [POST] /review/intelligentPartner/ai/finish
 */
export function postReviewIntelligentPartnerAiFinish(
    data: PostReviewIntelligentPartnerAiFinishBody
): Promise<BaseResponseAiDialogFinishResultResponse>;
export function postReviewIntelligentPartnerAiFinish(
    data: PostReviewIntelligentPartnerAiFinishBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseAiDialogFinishResultResponse>;
export function postReviewIntelligentPartnerAiFinish(
    data: PostReviewIntelligentPartnerAiFinishBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseAiDialogFinishResultResponse> {
    return request<PostReviewIntelligentPartnerAiFinishBody, never, never>(
        '/review/intelligentPartner/ai/finish',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postReviewIntelligentPartnerAiFinish',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-对话流程(节点, 全局配置, 客户画像)'],
        path: '/review/intelligentPartner/ai/finish',
        method: 'post',
    },
];
